<template>
  <div :class="modalHolder">
    <div class="modal_info medium">
      <div class="modal_info--inner">
        <article v-if="currentItem.isCast" class="cast_article">
          <h4 class="cast_article--title">{{currentItem.title}}</h4>
          <p class="cast_article--subtitle">{{currentItem.role}}</p>
          <p class="cast_article--intro" v-html="currentItem.intro"></p>
        </article>

        <article v-else class="staff_article_modal">
          <p class="staff_article_modal--subtitle">{{currentItem.role}}</p>
          <h3 class="staff_article_modal--title">{{currentItem.title}}</h3>
          <p class="staff_article_modal--intro" v-html="currentItem.intro"></p>
        </article>

        <button type="button" class="modal_info--close" name="close" @click="closeModal"><svg class="icon icon-close-button"><use xlink:href="#icon-close-button"></use></svg></button>
      </div>
    </div>

    <span class="modal_info--overlay" @click="closeModal"></span>
  </div>
</template>

<script>
export default {
  name: 'modal-info',
  props: {
    isActive: Boolean,
    currentItem: Object
  },
  data () {
    return {
    }
  },
  computed: {
    modalHolder () {
      if (this.isActive) {
        return 'modal_info--holder active'
      } else {
        return 'modal_info--holder'
      }
    }
  },
  methods: {
    closeModal () {
      this.$emit('closeModal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalInfo.vue